/*
 *  Copyright © 2025 Cenozon Inc. All Rights Reserved.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';
import { styled } from '@mui/material/styles';
import { clearSnackbar } from '../../store/action/snackbarAction';

const StyledDiv = styled('div')(({ theme }) => ({
   width: '100%',
   '& > * + *': {
      marginTop: theme.spacing(2)
   }
}));

export default function SnackBar() {
   const dispatch = useDispatch();
   const { successSnackbarMessage, snackbarOpen, failureSnackbarMessage, severity } = useSelector(
      state => state.snackbar
   );

   function handleClose() {
      dispatch(clearSnackbar());
   }

   return (
      <StyledDiv>
         <Snackbar 
            open={snackbarOpen} 
            autoHideDuration={4000} 
            onClose={handleClose} 
            anchorOrigin={{
               vertical: 'bottom',
               horizontal: 'right'
            }}
         >
            <Alert 
               onClose={handleClose} 
               severity={severity} 
               elevation={6} 
               variant="filled"
            >
               {severity === 'success' ? successSnackbarMessage : failureSnackbarMessage}
            </Alert>
         </Snackbar>
      </StyledDiv>
   );
}